import type { ReleaseNote } from "./types";

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    version: "v2.0",
    date: "2026/09/01",
    title: "マイページ（β版）を追加・日報と日程調整・設定の端末間の引き継ぎ",
    isNew: true,
    highlights: [
      {
        text: "マイページ（β版）を追加しました。画面下のメニューに「マイページ」が加わり、今日の予定・日報・日程調整・活動サマリを1つの画面から確認できます。（※マイページと、その中の日報・日程調整は現在β版です。準備ができたテナント様から順次ご利用いただけるようになります）",
      },
      {
        text: "日報（β版）を追加しました。その日の商談記録から日報の下書きが自動で作られ、週報・月報としても振り返れます。本文のもとになった記録から、実際の商談記録へそのまま移動できます。",
      },
      {
        text: "日程調整（β版）を追加しました。候補の日時を作ってお客様へリンクをお送りすると、お客様はログインなしで候補ごとに ○ × でご回答いただけます。確定・日時の変更・取りやめは、メールとカレンダーファイル（.ics）でお相手に届きます。",
      },
      {
        text: "通知バッジ・お知らせの既読・AI音声の音量・検索履歴・記録モードの選択などの設定を、アカウントに保存するようにしました。端末やブラウザを変えても、同じ設定でご利用いただけます。",
      },
    ],
    improvements: [
      {
        text: "商談記録・顧客一覧・録音の各画面で、検索の入口と並び替えの見せ方を揃えました。並び替えはボタンで選べるようになっています。",
      },
    ],
    bugfixes: [
      {
        text: "「商談の振り返りを記録」で、議事録の内容ではなく商談記録の項目についての質問に逸れてしまう不具合を修正しました。",
      },
      {
        text: "商談の記録が「処理中」のまま完了しない場合がある不具合を修正しました。すでに残ってしまっている記録も自動で回収されます。",
      },
      {
        text: "ヒアリングメモに、実際には話していない文言が混ざる場合がある不具合を修正しました。",
      },
      {
        text: "未読のリリースノートがあっても、メニューに未読の印が表示されない不具合を修正しました。",
      },
    ],
  },
  {
    version: "v1.9.1",
    date: "2026/08/25",
    title:
      "デフォルトプリセットを「商談記録（法人）」に改名・お客様情報の紐づけ改善・問い合わせ前にAIへ質問可能に",
    isNew: false,
    highlights: [
      {
        text: "何が選択されているか分かりやすくなるよう、プリセット「デフォルト」の名称を「商談記録（法人）」に変更しました。",
      },
      {
        text: "商談の詳細・編集画面で、お客様の紐づけ確認をよりスムーズにしました。編集画面でその場で候補を確認・選択でき、詳細画面でもお客様マスタの登録内容を確認できます。",
      },
      {
        text: "「メニュー」→「お問い合わせ」から、分からない事を「AIへ質問」できるようになりました。AIに質問しても解決しない場合は、そのままお問い合わせフォームへ進めます。",
      },
    ],
    improvements: [
      {
        text: "使い方ガイドの内容を最新の情報に更新しました。",
      },
    ],
    bugfixes: [
      {
        text: "まれに画面の切り替えが止まったまま戻らなくなる不具合を修正しました。",
      },
      {
        text: "削除した議事録がゴミ箱に表示されず、復元・完全削除ができない不具合を修正しました（「議事録」タブを追加しています）。",
      },
      {
        text: "ご自身以外の商談を編集・削除しようとした際に、操作できない理由が表示されるようになりました。",
      },
      {
        text: "通知の件数が多い場合に、一部の通知が一覧に表示されない不具合を修正しました。",
      },
      {
        text: "商談記録の項目が、すべてカタカナで記録される場合がある不具合を修正しました。",
      },
      {
        text: "対話モードで、同じ項目について2回お答えいただいた際、後から伝えた内容が記録に反映されない不具合を修正しました。",
      },
    ],
  },
  {
    version: "v1.8.3",
    date: "2026/08/04",
    title: "検索機能の改善・対話キャラクターの追加・顧客レポート（β版）のリニューアル",
    isNew: false,
    highlights: [
      {
        text: "「検索」機能を改善し、検索対象をメモ・議事録などにも拡大しました。あわせて絞り込み条件（種類・プリセットなど）を「詳細フィルタ」に整理し、検索結果の表示も見やすくなりました。",
      },
      {
        text: "対話モードで記録する際の対話相手として、女性キャラクターを追加しました。あわせて、各画面に適宜、Unizoロゴから誕生したゾウのキャラクターを追加しました。",
      },
      {
        text: "顧客情報に「その他ヒアリングできた事項」欄を追加しました。既存項目に当てはまらない情報がある場合でも、情報が保存されやすくなります。",
      },
    ],
    improvements: [
      {
        text: "顧客レポート機能（β版）の画面デザインを見やすく刷新し、情報充足度が正しく表示されない不具合も修正しました。(※本機能は現在β版として提供しております)",
      },
      {
        text: "画面のUnizoロゴを押した場合、HOMEに遷移できるようになりました。",
      },
    ],
    bugfixes: [
      {
        text: "Android端末の対話モードで、ご利用の環境によって、AIの声が聞こえない場合がある不具合を修正しました。",
      },
    ],
  },
  {
    version: "v1.8.2",
    date: "2026/07/28",
    title: "お問い合わせ機能の追加・録音対話の品質改善",
    isNew: false,
    highlights: [
      {
        text: "お問い合わせ機能を追加しました。メニューの「お問い合わせ」から、操作方法のご質問や不具合のご報告をアプリ内で送信できるようになりました。回答が届くと通知でお知らせします。解決しなかった場合は、元のお問い合わせの続きとして再度送信できます。",
      },
    ],
    improvements: [
      {
        text: "録音対話で、顧客マスタに登録済みのお客様情報をAIが一つずつ読み上げて確認することがある挙動を見直し、一言に留めるようにしました。",
      },
    ],
    bugfixes: [
      {
        text: "録音対話で、AIが不要なシステム文言を話してしまうことがある不具合や、すべての項目に回答しても記録が自動で終了しないことがある不具合を修正しました。",
      },
      {
        text: "「過去の記録から作成」で記録を開始した際に、引き継いだお客様情報や担当者が正しく引き継がれないことがある不具合を修正しました。",
      },
      {
        text: "商談タイトルが長い場合に画面が横に崩れる不具合を修正しました。あわせて、商談詳細ではタイトルが省略されず全文折り返して表示されるようになりました。",
      },
    ],
  },
  {
    version: "v1.8.1",
    date: "2026/07/21",
    title: "議事録の編集機能・会社名検索の改善・細かな使い勝手の向上",
    isNew: false,
    highlights: [
      {
        text: "議事録の「決定事項」「Nextアクション」を、画面上でそのまま編集できるようになりました。AIが整理した内容をタップして修正でき、担当者も本文にあわせて記録されます。",
      },
      {
        text: "商談記録時の会社名検索を改善しました。本社所在地に近い企業が優先して表示されるようになり、似た名前の会社が多い場合でも目的の企業を見つけやすくなりました。",
      },
      {
        text: "自由記録モードの記録整理を改善しました。話した内容を項目ごとに整理する処理を見直し、担当者などの情報が漏れたり重複したりしにくくなりました。",
      },
    ],
    improvements: [
      {
        text: "商談記録・メモ一覧の並び替えをプルダウンで選べるようにし、「顧客登録順」の並び替えを追加しました。",
      },
      {
        text: "自由記録モードの録音中のプリセット変更の操作を分かりやすくし、画面に表示されているプリセットの内容がそのまま保存されるようにしました。",
      },
    ],
    bugfixes: [
      {
        text: "iPadで商談記録のコピーが「コピーに失敗しました」となることがある不具合を修正しました。",
      },
      {
        text: "「過去の記録から作成」で商談を記録した際、選択した担当者がカタカナ表記で重複して登録されてしまう不具合を修正しました。",
      },
      {
        text: "議事録の詳細画面からブラウザの「戻る」で戻ると、メモ一覧に移動してしまう不具合を修正しました。",
      },
      {
        text: "Androidのホーム画面でアプリのアイコンが大きく表示されてしまう問題を修正しました。",
      },
    ],
  },
  {
    version: "v1.8.0",
    date: "2026/07/13",
    title: "顧客一覧画面の追加・議事録機能の追加・Unizoロゴの刷新",
    isNew: false,
    highlights: [
      {
        text: "顧客一覧画面を追加しました。自分が担当する顧客を一覧で管理でき、顧客を指定して商談を記録できます。また、担当顧客を引き継げる機能を使用することで、すぐに引き継いだ顧客の商談記録にアクセスできます。",
      },
      {
        text: "議事録機能を追加しました。「録音」タブから、長時間の会議（最大60分）を録音することができます。録音終了後はAIが「要約・決定事項・Nextアクション」を自動で整理します。Nextアクションは自身のToDoとして登録することで、会議後のフォローに活用できます。",
      },
      {
        text: "Unizoのロゴを刷新しました。「聞いたことを決して忘れない」と言われている象をモチーフに、音声の波形を印象づけるロゴになっています。",
      },
    ],
    improvements: [
      {
        text: "トップページの商談記録から、直接商談内容のコピーや商談記録の編集を行えるようにしました。",
      },
      {
        text: "すべての画面のヘッダーデザインを統一しました。どの画面でも同じ場所で迷わず操作できるようになりました。",
      },
    ],
    bugfixes: [
      {
        text: "メモ機能の文字起こしに、管理者が登録した辞書（専門用語の表記）が反映されない不具合を修正しました。",
      },
      {
        text: "使い方ガイドの記事タイトルが二重に表示される不具合を修正しました。",
      },
    ],
  },
  {
    version: "v1.7.5",
    date: "2026/07/06",
    title: "音声記録の精度向上・メモ/ToDoの改善・顧客設定の簡易化・コピー機能の改善",
    isNew: false,
    highlights: [
      {
        text: "音声記録を改善しました。音声認識モデルと文字起こし・整理の処理を全面的に見直し、会話から項目へ整理する際の情報の抜け漏れを減らして、商談記録の精度を高めました。意味の通らない文言も記録されにくくなりました。",
      },
      {
        text: "音声メモ・ToDo機能の使い勝手を改善しました。AIが提案するToDo候補を再生成でき、削除した音声メモをゴミ箱から戻せるようになりました。記録の開始や整形中の表示もよりスムーズになりました。",
      },
      {
        text: "企業担当者や個人のお客様を、かんたんに設定できるようになりました。顧客マスタで企業だけでなく個人も管理でき、音声で聞き取った担当者名を登録済みの漢字表記で自動表示するなど、登録の手間を減らしました。",
      },
    ],
    improvements: [
      {
        text: "商談記録のテキストコピーを改善しました。定型文フォーマットに沿った整形、コピー内容の文字数の最適化、余分な記号や「未設定」項目の削減に対応し、そのまま貼り付けやすくなりました。",
      },
      {
        text: "顧客マスタの個人のお客様の情報を充実させ、登録できる項目を増やしました。",
      },
      {
        text: "部署を設定できるようになり、部署ごとに利用するプリセットを絞り込めるようになりました。所属部署に応じて、記録開始時に適したプリセットが表示されます。",
      },
      {
        text: "ログイン状態がより長く維持されるようになりました。また、アプリの最新版がより早く反映されるようになりました。",
      },
    ],
    bugfixes: [
      {
        text: "検索結果から商談詳細を開いた後、「戻る」で元の検索結果に戻れるようになりました。",
      },
      {
        text: "商談一覧に一部の商談が表示されないことがある不具合を修正しました。",
      },
    ],
  },
  {
    version: "v1.7.0",
    date: "2026/06/01",
    title: "メモ機能の追加・HOME/検索画面の改善・通知リニューアル",
    isNew: false,
    highlights: [
      {
        text: "HOME画面と検索画面のUIを改善しました。より少ないタップで商談記録を開始でき、検索性も向上しました。",
      },
      {
        text: "メモ機能を追加しました。音声でメモを残し、企業に紐づけて管理したり、記録したメモからToDoを作成できるようになりました。",
      },
      {
        text: "通知機能をリニューアルしました。他のメンバーの商談作成や、時間のかかる処理の完了に気づきやすくなりました。",
      },
    ],
    improvements: [
      {
        text: "管理者により「短縮ユーザー名」でのログイン設定がされている場合、「メニュー」の「基本設定」から、次回以降のログインがワンタップでアクセスできるようになる機能が追加されました。",
      },
      {
        text: "音声記録（文字起こし）の精度を向上しました。",
      },
    ],
    bugfixes: [
      {
        text: "ログアウト後にホーム画面のアプリを再起動すると、ログイン状態が残ってしまうことがある不具合を解消しました。",
      },
    ],
  },
  {
    version: "v1.6.0",
    date: "2026/05/11",
    title: "パスキー設定で簡単ログインが可能に",
    isNew: false,
    highlights: [
      {
        text: "ログイン時にパスキー設定（指紋認証や顔認証）ができ、簡単にログインできるようになりました。パスキー管理（追加や削除）は「メニュー」の「基本設定」から行えます。",
      },
    ],
    improvements: [
      {
        text: "Safariブラウザでの音声録音（自由記録モード含む）に対応しました。",
      },
      {
        text: "Androidスマートフォンでも、商談記録のドラッグ＆ドロップ操作ができるようになりました。",
      },
    ],
    bugfixes: [
      {
        text: "商談記録の選択時に、所属フォルダの情報が非表示になる不具合を解消しました。",
      },
      {
        text: "ログイン情報を保持したにもかかわらず、保持されないことがある不具合を解消しました。",
      },
    ],
  },
  {
    version: "v1.5.0",
    date: "2026/04/19",
    title: "グループ要約機能・基本設定機能・お知らせページ新設",
    highlights: [
      {
        text: "「商談グループ」内にある複数の商談記録の情報をまとめる要約機能ができました。",
      },
      {
        text: "メニューに基本設定ページを追加しました。ユーザー情報の確認とパスワード変更ができるようになりました。",
      },
      {
        text: "お知らせページを新設しました。本リリースノートもここに集約されました。",
      },
    ],
    improvements: [
      {
        text: "商談記録を編集する際、顧客マスタに未登録の企業を公開データベース（gBizInfo）から選択して正規登録できるようになりました。",
      },
      {
        text: "ドラッグ&ドロップで商談記録のグループ移動ができるようになりました。(※Androidのみ非対応)",
      },
      {
        text: "自由記録モードの記録完了後、すぐに次の画面へ移動できるようになりました。",
      },
      {
        text: "自由記録モードの記録中に、登録プリセットに応じて画面表示を切り替えられるようになりました。",
      },
    ],
    bugfixes: [],
  },
  {
    version: "v1.4.0",
    date: "2026/04/02",
    title: "商談日時編集・絞り込み機能改善",
    highlights: [
      {
        text: "絞り込み機能を改善しました。絞り込みバーのデザイン刷新・検索条件チップの折り返し対応・件数表示に対応しました。",
      },
      {
        text: "商談日時を編集できるようになりました。",
      },
    ],
    improvements: [
      {
        text: "商談グループフィルターの件数がリアルタイムで反映されるようになりました。",
      },
      {
        text: "ダッシュボードの絞り込みのデフォルトを「全員」に変更しました。",
      },
      {
        text: "商談詳細画面のUIを改善しました。",
      },
    ],
    bugfixes: [
      {
        text: "商談グループからの記録開始時にモード選択が表示されるようになりました。",
      },
    ],
  },
  {
    version: "v1.3.0",
    date: "2026/03/19",
    title: "商談相手をコピーして記録・自由記録モード対応・ゴミ箱機能",
    highlights: [
      {
        text: "過去の商談をベースに、商談相手をコピーして記録できる機能を追加しました。",
      },
      {
        text: "慣れてきた方や少しでも時短したい方向けに、AIとの対話なしに商談を記録できる自由記録モードを追加しました。",
      },
      {
        text: "ゴミ箱機能を追加しました。最大30日間保管され、削除した商談を復元もできます。",
      },
    ],
    improvements: [
      {
        text: "役職のみの担当者情報も記録できるようになりました。",
      },
      {
        text: "より使いやすくなるようデザインを修正しました。",
      },
    ],
    bugfixes: [
      {
        text: "録音解析中にリダイレクトが繰り返される問題を修正しました。",
      },
    ],
  },
  {
    version: "v1.2.0",
    date: "2026/03/06",
    title: "お気に入り・閲覧履歴・検索条件履歴",
    highlights: [
      {
        text: "お気に入り機能を追加しました。重要な商談や商談グループを最大50件まで登録でき、すばやくアクセスできます。",
      },
      {
        text: "閲覧履歴機能を追加しました。最近見た商談を最新50件までアクセスできます。",
      },
      {
        text: "検索条件の履歴が最大10件まで自動保存されます。よく使う検索条件はピン留めすることができます。",
      },
    ],
    improvements: [
      {
        text: "商談検索結果でグループ内の商談を個別に表示できるようになりました。",
      },
      {
        text: "録音画面にミュートボタンを追加しました。",
      },
      {
        text: "商談詳細画面のUIをカード形式にリニューアルしました。",
      },
    ],
    bugfixes: [
      {
        text: "録音再開時やブラウザバック時に音声が二重再生される問題を修正しました。",
      },
    ],
  },
  {
    version: "v1.1.0",
    date: "2026/02/16",
    title: "商談グループ・自動抽出・絞り込み",
    highlights: [
      {
        text: "商談グループ機能を追加しました。商談を長押しすると任意の商談グループに移動させることができます。",
      },
      {
        text: "商談データの自動抽出（法人名・担当者・ニーズ・次のアクション）に対応しました。",
      },
      {
        text: "自分が登録した商談、自分以外が登録した商談を1Clickで絞り込めるようになりました。",
      },
    ],
    improvements: [
      {
        text: "商談記録のタイトルが商談内容から自動生成されるようになりました。",
      },
      {
        text: "IPホワイトリスト機能を追加しました。",
      },
    ],
    bugfixes: [
      {
        text: "商談記録中に画面がOFFになると中断される問題を解消しました。",
      },
    ],
  },
  {
    version: "v1.0.0",
    date: "2026/01/26",
    title: "Unizoリリース",
    highlights: [
      {
        text: "Unizoがリリースされました！画面下部の「＋」アイコンから、音声入力で商談の内容、顧客の反応、ネクストアクションなどを記録できます。",
      },
    ],
    improvements: [],
    bugfixes: [],
  },
];
